import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon } from 'lucide-react';
export function EducationSection() {
  return <section id="education" className="py-20 sm:py-28 px-4 bg-slate-900/50" aria-labelledby="education-heading" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-53">
          <h2 id="education-heading" className="text-3xl sm:text-4xl font-bold text-white mb-4" data-id="element-54">
            Education
          </h2>
          <div className="w-20 h-1 bg-emerald-500 mx-auto rounded-full" aria-hidden="true" data-id="element-55" />
        </motion.div>

        <div className="space-y-6" data-id="element-56">
          {/* Education Card 1 */}
          <motion.article initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 sm:p-8 hover:border-slate-600 transition-colors" data-id="element-57">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-58">
              <div className="flex-shrink-0" data-id="element-59">
                <div className="w-14 h-14 bg-emerald-500/10 border border-emerald-500/20 rounded-xl flex items-center justify-center" data-id="element-60">
                  <GraduationCapIcon className="w-7 h-7 text-emerald-400" aria-hidden="true" data-id="element-61" />
                </div>
              </div>
              <div className="flex-1" data-id="element-62">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2" data-id="element-63">
                  <h3 className="text-xl font-bold text-white" data-id="element-64">
                    Diploma of Information Technology (General)
                  </h3>
                  <span className="text-sm text-emerald-400 font-medium whitespace-nowrap" data-id="element-65">
                    <time dateTime="2020" data-id="element-66">2025</time> -{' '}
                    <time dateTime="2024" data-id="element-67">Current</time>
                  </span>
                </div>
                <p className="text-slate-400 mb-4" data-id="element-68">TAFE NSW</p>
                <div className="space-y-2" data-id="element-69">
                  <div className="flex flex-wrap gap-2 mt-4" data-id="element-70">
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-71">
                      Basic AI and ML
                    </span>
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-72">
                      Project Management
                    </span>
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-73">
                      Web Development
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.article>

          {/* Education Card 2 - Certification */}
          <motion.article initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 sm:p-8 hover:border-slate-600 transition-colors" data-id="element-74">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4" data-id="element-75">
              <div className="flex-shrink-0" data-id="element-76">
                <div className="w-14 h-14 bg-amber-500/10 border border-amber-500/20 rounded-xl flex items-center justify-center" data-id="element-77">
                  <GraduationCapIcon className="w-7 h-7 text-amber-400" aria-hidden="true" data-id="element-78" />
                </div>
              </div>
              <div className="flex-1" data-id="element-79">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2" data-id="element-80">
                  <h3 className="text-xl font-bold text-white" data-id="element-81">
                    Bachelor of Software Engineer
                  </h3>
                  <span className="text-sm text-amber-400 font-medium whitespace-nowrap" data-id="element-82">
                    <time dateTime="2022" data-id="element-83">2020 - 2024</time>
                  </span>
                </div>
                <p className="text-slate-400 mb-4" data-id="element-84">
                  Ton Duc Thang University - Vietnam
                </p>
                <div className="space-y-2" data-id="element-85">
                  <div className="flex flex-wrap gap-2 mt-4" data-id="element-86">
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-87">
                      Web Development
                    </span>
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-88">
                      Basic Cross-platform Development
                    </span>
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-89">
                      Database Management
                    </span>
                    <span className="px-2.5 py-1 bg-slate-700/50 border border-slate-600 rounded-md text-xs text-slate-300" data-id="element-90">
                      Business Analysis
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}